import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // Define your initial state properties here
    isLoggedIn: true, // assume user is logged in by default unless set otherwise
};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    // Define your reducers here to update the state
    setIsLoggedIn(state, action) {
      state.isLoggedIn = action.payload;
    },
  },
});

export const { 
    setIsLoggedIn,
} = accountSlice.actions;

export default accountSlice.reducer;